import { Component, Input } from '@angular/core';

import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { CommonModule } from '@angular/common';
import { LabelType, ShLabelComponent, ShProgressLabelComponent } from '../../../../../elements/public_api';
import { ShBaseCell } from '../_base/base-cell.component';
import { AsyncStatusCell } from './async-status-cell.entity';

@Component({
    standalone: true,
    selector: 'sh-async-status-cell',
    templateUrl: './async-status-cell.component.html',
    imports: [CommonModule, ShProgressLabelComponent, ShLabelComponent]
})
export class ShAsyncStatusCellComponent<T> extends ShBaseCell {
    @Input() public cell!: AsyncStatusCell<T>;

    public get label$(): Observable<string> {
        return this.cell.asyncData.pipe(
            map(data => this.cell.labelFactory(data)),
            startWith(this.cell.placeholderLabel)
        );
    }

    public get labelType$(): Observable<LabelType> {
        return this.cell.asyncData.pipe(
            map(data => this.cell.labelTypeFactory(data)),
            startWith(this.cell.placeholderLabelType)
        );
    }

    public get useProgress$(): Observable<boolean> {
        return this.cell.asyncData.pipe(
            map(data => this.cell.useProgressFactory(data)),
            startWith(false)
        );
    }
}
